import { IColumnObject } from "../pages/dataConfig/News/ITable";

const itemColumns = {
    id: {
        dbField: '_id',
        displayField: 'ID',
    },
    validFrom: {
        dbField: 'validFrom',
        displayField: 'Valid from (UTC)',
    },
    validTo: {
        dbField: 'validTo',
        displayField: 'Valid to (UTC)',
    },
    title: {
        dbField: 'title',
        displayField: 'Title',
    },
    content: {
        dbField: 'content',
        displayField: 'Content',
    },
    updatedAt: {
        dbField: 'updatedAt',
        displayField: 'Last updated',
    },
    updatedBy: {
        dbField: 'updatedBy',
        displayField: '',
    },
    actions: { // hidden, to identify actions that list will be rendered (like edit, delete)
        dbField: 'actions', // not used in backend
        displayField: '',
    },
};

// table columns for news list
const tableColumns: IColumnObject[] = [
    {
        ...itemColumns.validFrom,
        width: '170px',
        minWidth: '170px',
    },
    {
        ...itemColumns.validTo,
        width: '170px',
        minWidth: '170px',
    },
    {
        ...itemColumns.title,
        width: '300px',
        minWidth: '250px',
    },
    {
        ...itemColumns.content,
        minWidth: '400px',
    },
    {
        ...itemColumns.updatedAt,
        width: '270px',
        minWidth: '270px',
    },
];

// required fields for news modal (add, edit)
const NEWS_REQUIRED_FIELDS = [
    itemColumns.validFrom.dbField,
    itemColumns.validTo.dbField,
    itemColumns.title.dbField,
    itemColumns.content.dbField,
];

const defaultChartDisplay = '--';

export {
    itemColumns,
    tableColumns,
    NEWS_REQUIRED_FIELDS,
    defaultChartDisplay
};
